import React, { useState, useEffect } from "react";
import JSZip from "jszip";
import "./absenteeism.scss";
import "./cashAdvance.scss";
import { HiArrowLongRight } from "react-icons/hi2";
import generatePdf from "./pdfWorker.js"; // Import the generatePdf function
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setDownloadState } from "../../../../../store/userSlice";

const AgreementGenerator = ({ candidates, progress, setProgress }) => {
  const dispatch = useDispatch();
  const [downloadingZip, setDownloadingZip] = useState(false);
  const candidateIds = candidates.map((candidate) => candidate.id);
  const downloadHandler = () => {
    dispatch(setDownloadState({ progress: true }));
    const iframeTag = document.createElement("iframe");
    iframeTag.src = `/download?arrivalId=${
      candidates[0]?.arrival_notification_id
    }&candidates=${JSON.stringify(candidateIds)}`;
    iframeTag.className =
      "fixed bottom-3 right-3 shadow-lg rounded-md h-20 bg-slate-100";
    iframeTag.scrolling = "no";
    iframeTag.setAttribute("id", "downloading-progress");
    document.body.appendChild(iframeTag);
  };
  return (
    <>
      {/* <Link
        to={`/dashboard/download?arrivalId=${
          candidates[0]?.arrival_notification_id
        }&candidates=${JSON.stringify(candidateIds)}`}
        target="_blank"
      > */}
      <button className="w-full " onClick={downloadHandler}>
        {/* <button className="w-full" onClick={generateAllAgreements}> */}
        <p
          className={`bg-white shadow-sm p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-4`}
        >
          {downloadingZip ? (
            <>{`Generating and Downloading... ${progress}%`}</>
          ) : (
            <>
              Download All Agreements as ZIP{" "}
              <HiArrowLongRight size={"1.2rem"} />
            </>
          )}
        </p>
      </button>
      {/* </Link> */}
    </>
  );
};

export default AgreementGenerator;

export function getAbsenteeismContent(person) {
  const content = `
  <body>
    <div class="container1">
      <div class="page-1">
        <center><img src="asset/Mosaed_logo.JPG" /></center>
        <table class="header">
          <tr>
            <td>
              <b
                >Mosaed Business Contracting Co.<br />
                C.R. 1010777155
              </b>
            </td>
            <td class="last-child">
              <b>شركة مساعد الأعمال للمقاولات س :ت <br />1010777155</b>
            </td>
          </tr>
        </table>
        <div class="line_main">
        <div class="lines"></div>
        <div class="lines"></div>
        </div>
          <div class="date">Date: 5-jan-23</div>
          <p class="para">
            I PRAVEEN KUMAR, Employee ID, INDIAN nationality bearing Passport
            No. $7506493, hereby confirm that I have the read the below given
            policy and understood all terms and conditions.
          </p>
          <p class="para">
            I confirm and accept all the terms and conditions mentioned below.
          </p>
          <p class="para">
            I also confirm if I get terminated due to absenteeism policy, I will
            repay my company all the expenses incurred on me.
          </p>
          <h4><u>EMPLOYEE ABSENTEEISM POLICY</u></h4>
          <p class="para-2">
            Following shall be implemented to monitor employee absenteeism from
            the month of June 2022.
          </p>
          <p class="para">
            In case of any queries, please contact the Project Coordinators /
            Site Coordinators only.
          </p>
          <table class="table-abs">
            <tr>
              <th style="width:80px">Days Absent per Month</th>
              <th style="width:140px">Warning Issued</th>
              <th>Penalty</th>
              <th>Remarks</th>
            </tr>
            <tr>
              <td>1</td>
              <td>Yes</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>2</td>
              <td>Yes</td>
              <td>1 day wage</td>
              <td>1 day will be deducted in monthly salary</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Yes</td>
              <td>1+1 = 2-day wage</td>
              <td>2 days will be deducted in monthly salary</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Yes</td>
              <td>1+1+1=3 days + SAR 50</td>
              <td>3 days + SAR 50 fine will be deducted in monthly salary</td>
            </tr>
            <tr>
              <td>More than 4 days</td>
              <td>Immediate Termination</td>
              <td></td>
              <td>As per company policy</td>
            </tr>
          </table>
          <h4><u>MEDICAL SICKNESS CERTIFICATE</u></h4>
          <ol>
            <li>
              If an employee remains absent due to sickness, then he has to
              submit ALL of the following documents to the Project Coordinator:
              <div class="intent">
                a. Sick Leave from Clinic with Clinic Stamp <br />b. Doctor's
                prescription with Doctor's Stamp<br />
                C. Pharmacy invoice of medicines
              </div>
            </li>
            <li>
              If any of the above is not submitted, then that day (when he
              visited the Clinic) will be considered as <b><u>ABSENT</u></b>
            </li>
          </ol>
          <br />
          <table class="sign">
            <tr>
              <td>Name:</td>
              <td>PRAVEEN KUMAR</td>
              <td>Signature:</td>
              <td></td>
            </tr>
            <tr>
              <td>Position</td>
              <td>HEAVY DRIVER CUM LOADING UNLOADING</td>
              <td>Thumb Impression:</td>
              <td></td>
            </tr>
          </table>
        <br /><br />
        <div class="fLines lines"></div>
        <div class="lines"></div>
        <div class="footer">
          <p>
            لمملكة العربية السعودية - الرياض - الدائري الشرقي - مخرج 13 <br />
            Kingdom of Saudi Arabia - Riyadh - Eastern Ring - Outlet 13
          </p>
        </div>
      </div>
    </div>
  </body>
</html>
  `;

  return content;
}

export function getCashAdvanceContent(person) {
  const content = `
      <div class="container2">
        <div class="page-1">
          <center><img src="asset/Mosaed_logo.JPG" /></center>
          <table class="header">
            <tr>
              <td>
                <b
                  >Mosaed Business Contracting Co.<br />
                  C.R. 1010777155
                </b>
              </td>
              <td class="last-child">
                <b>شركة مساعد الأعمال للمقاولات س :ت <br />1010777155</b>
              </td>
            </tr>
          </table>
          <div class="lines"></div>
          <div class="lines"></div>
          <div class="content">
            <h3><u>CASH ADVANCE ON ARRIVAL FOR FOOD</u></h3>
            <div class="date">Date: 1/5/2023</div>
            <p class="para">
              I,Mr.<b>PRAVEEN KUMAR</b> Employee ID, bearing INDIAN Passport
              Number $7506493 and hereby state that.<br />
              ➤ I request the Company to grant me an advance amount of SAR 200.00
              for my basic expenses. <br />➤ I hereby confirm that I have received
              the amount.<br />➤ I understand & authorize the Company to deduct
              the advance from my salary on monthly basis.<br />➤ I acknowledge
              that I will not hold the Company liable for any deductions in my
              salary for the mentioned Loan amount.<br />
              ➤ I also acknowledge that the Company is authorized to take any
              legal action for the recovery of the Advance amount and the expenses
              for the same will borne by me.
            </p>
            <table class="sign">
              <tr>
                <td>
                  ____________________<br />
                  Receiver Signature<br />
                  Position: HEAVY DRIVER CUM LOADING UNLOADING <br />Mobile No.:
                </td>
                <td>
                  ____________________<br />
                  Project Coordinator: ABDUL GAFFAR <br />Project: FLOW LOGISTIC
                  <br />Mobile Number:580200663
                </td>
              </tr>
            </table>
            <h4>
              <b><u>Emergency Home Country Number </u></b>
            </h4>
            <table class="table-Emergency">
              <tr>
                <td>Name:</td>
                <td></td>
              </tr>
              <tr>
                <td>Relation:</td>
                <td></td>
              </tr>
              <tr>
                <td>Contact Number:</td>
                <td></td>
              </tr>
            </table>
          </div>
  
          <div class="fLines lines"></div>
          <div class="lines"></div>
          <div class="footer">
            <p>
              لمملكة العربية السعودية - الرياض - الدائري الشرقي - مخرج 13 <br />
              Kingdom of Saudi Arabia - Riyadh - Eastern Ring - Outlet 13
            </p>
          </div>
        </div>
      </div>
  `;

  return content;
}

export function getEmployeeContent(person) {
  const content = `<!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Employment Agreement</title>
      <style>
        .container {
          width: auto;
          margin: 0 auto;
          padding: 0px 30px;
          font-family: DejaVu Sans, sans-serif;
          font-size: 10px;
          box-sizing: border-box;
        }
        .container td {
          padding-bottom: 15px !important;
        }
        .container .page-1 {
          height: 100%;
        }
        .container .page-2 {
          height: 100%;
        }
        .container .page-3 {
          height: 100%;
        }
        .container img {
          align-items: center;
          width: 15%;
        }
        .container table {
          border-collapse: collapse;
          width: 100%;
        }
        .container .header-1 {
          margin-top: 5px;
        }
        .container .header-1 .empHeader {
          text-transform: uppercase;
          font-weight: bold;
        }
        .container .header-1 .empHeader td:first-child {
          padding-left: 50px;
        }
        .container .Date {
          margin-top: 15px;
        }
        .container .Date td:last-child {
          text-align: right;
        }
        .container .header td:last-child {
          text-align: right;
        }
        .container .header td:first-child {
          border: none;
          text-align: left;
          font-weight: none;
        }
        .container .last-child {
          text-align: right;
        }
        .container .lines {
          border: solid 1px rgba(0, 0, 0, 0.265);
          margin-top: 2px;
        }
        .container .table-1 {
          margin-top: 15px;
        }
        .container .table-1 td {
          border: solid 1px black;
          padding: 0 5px;
          padding-bottom: 15px;

        }
        .container .table-1 td:first-child {
          width: 50%;
          padding: 0 5px;
        }
        .container .table-1 td:last-child {
          width: 50%;
          text-align: right;
        }
        .container .table-2 td:first-child {
          width: 50%;
          padding: 0 5px;
        }
        .container .table-2 td:first-child + td {
          text-align: right;
          padding: 0 5px;
        }
        .container .table-2 td:first-child + td + td {
          text-align: right;
          padding: 0 5px;
          width: 15%;
        }
        .container .table-3 td:first-child + td {
          width: 45%;
          padding: 0 5px;
        }
        .container .table-3 td:first-child + td + td {
          width: 30%;
          text-align: right;
          padding: 0 5px;
        }
        .container .table-3 td:first-child {
          width: 5%;
          text-align: center;
        }
        .container .table-3 td:last-child {
          width: 5%;
          text-align: center;
        }
        .container .table-3 th:last-child {
          text-align: right;
        }
        .container .table-2 td {
          border: solid 1px black;
        }
        .container .table-2 {
          margin-top: 15px;
        }
        .container .table-3 {
          margin-top: 15px;
          height: 500px;
        }
        .container .table-3 td,
        .container th {
          border: solid 1px black;
        }
        .container .fLines {
          margin-top: 25px;
        }
        .container .footer {
          text-align: center;
        }
        .container .table-4 {
          margin-top: 50px;
        }
        .container .table-4 th {
          border: none;
          padding-bottom: 20px;
        }
        .container .table-4 td {
          border: solid 1px black;
          padding: 0 5px;
        }
  
        .container .table-4 td:first-child {
          text-align: center;
        }
        .container .table-4 td:last-child {
          text-align: center;
        }
        .container .since {
          margin-top: 30px;
        }
        .container .sign-table td:last-child {
          text-align: right;
        }
        .container .salary-E {
          vertical-align: baseline;
          line-height: 20px;
        }
        .container .salary-A {
          text-align: right;
          vertical-align: baseline;
          line-height: 15px;
        }
        .container .undertaking {
          text-align: center;
          margin-top: 30px;
        }
        .container .undertaking-a {
          margin: 20px 0;
        }
        .container .undertaking-d {
          margin-bottom: 5px;
        }
        .container .undertaking-d-a {
          margin-bottom: 5px;
        }
        .container .date-u {
          margin-bottom: 10px;
        }
        .container .salary-row {
          vertical-align: baseline;
        }

        .container .table-1 td,th{
          padding-bottom:20px  
        }
  
        .container .u-table {
          width: 100%;
        }
        .container .u-table td {
          border: solid 1px black;
          padding: 2px 5px;
        }
        .container .u-table td + td + td + td {
          text-align: right;
        }
        .container .table-intend {
          margin-left: 20px;
        }
  
        .container .u-table-header td {
          border: solid 1px black;
          border-bottom: none;
          padding:0px 5px;
        }
        .container .Due-table td {
          border: solid 1px black;
          padding: 5px;
        }
        .container .Due-table td:last-child {
          width: 50%;
          text-align: right;
        }
        .container .Due-table {
          margin-top: 15px;
          width: 100%;
        }
        .container .sign {
          margin-top: 80px;
          margin-bottom: 20px;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="page-1">
          <center><img src="asset/Mosaed_logo.JPG" /></center>
          <table class="header">
            <tr>
              <td>
                <b
                  >Mosaed Business Contracting Co.<br />
                  C.R. 1010777155
                </b>
              </td>
              <td class="last-child">
                <b>شركة مساعد الأعمال للمقاولات س :ت <br />1010777155</b>
              </td>
            </tr>
          </table>
          <div class="lines"></div>
          <div class="lines"></div>
          <table class="header-1">
            <tr class="empHeader">
              <td>Employment Agreement</td>
              <td>عقد عمل</td>
            </tr>
          </table>
          <table class="Date">
            <tr>
              <td>Date: <b>1/5/2023</b></td>
              <td>1/5/2023 تاريخ:</td>
            </tr>
          </table>
          <table class="table-1">
            <tr>
              <td>
                This EMPLOYMENT contract is made between Mosaed Business
                Contracting Co., P.O. Box 275310, #204, 2nd floor, Al Malaz, Above
                Jarir book store, entry from behind, Al Hamidat street, Riyadh,
                +966-114547687, Fax:0112291047, KSA herein after called the
                (EMPLOYER) FIRST PARTY and the below (EMPLOYEE) SECOND PARTY:
              </td>
              <td>
                فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف الأول
                من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق بنود العقد
                بوظيفة (۱۱) على أن يلتزم الطرف الثاني بأداء واجباته ومسئولياته وكل
                ما يتعلق بوظيفته مما يكلفه به الطرف الأول
              </td>
            </tr>
          </table>
          <table class="table-2">
            <tbody>
              <tr>
                <td>Name: PRAVEEN KUMAR</td>
                <td>PRAVEEN KUMAR</td>
                <td>يتعلق</td>
              </tr>
              <tr>
                <td>Nationality: INDIAN</td>
                <td>INDIAN</td>
                <td>يتعلق</td>
              </tr>
              <tr>
                <td>Passport No. 57506493</td>
                <td>57506493</td>
                <td>يتعلقيتعلق</td>
              </tr>
              <tr>
                <td>Employee Code: 54552</td>
                <td>54552</td>
                <td>يتيتعلق</td>
              </tr>
            </tbody>
          </table>
          <table class="table-3">
            <tbody>
              <tr>
                <th colspan="2">Terms & Conditions of Employment</th>
                <th colspan="3">شركة مساعد الأعمال للمقاولات س :ت</th>
              </tr>
              <tr>
                <td>1.1</td>
                <td>Job Title: HEAVY DRIVER CUM LOADING UNLOADING</td>
                <td>HEAVY DRIVER CUM LOADING UNLOADING</td>
                <td>لمسمى الوظيفي</td>
                <td>1.1</td>
              </tr>
              <tr>
                <td>1.2</td>
                <td>Duration: 2 years (Two years)</td>
                <td colspan="2">لمسمى</td>
                <td>1.2</td>
              </tr>
              <tr>
                <td>1.3</td>
                <td>Contract starting Date: 1/5/2023</td>
                <td>1/5/2023</td>
                <td>لمسمى</td>
                <td>1.3</td>
              </tr>
              <tr>
                <td>1.4</td>
                <td>Probation Period: 3 months (Three months)</td>
                <td colspan="2">التجربة يعمل الطرف الثاني</td>
                <td>1.4</td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  The second party will work for the first party in his main
                  office or one of its branches or any place belonging to the
                  first party inside K.S.A as per the contract terms in position
                  of (1.1), the second party will oblige to do his duties and
                  responsibilities as required by the first party.
                </td>
                <td colspan="2">
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱) على أن يلتزم الطرف الثاني بأداء واجباته
                  ومسئولياته وكل ما يتعلق بوظيفته مما
                </td>
                <td>2</td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  Working hours will be 9hrs including prayer break hours per day
                  (6 days per week). Friday will be the official weekly rest day.
                  Excluded from this clause, will be some departments that are
                  required to work on Fridays in which case another day of the
                  week will be a rest day.
                </td>
                <td colspan="2">
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱)
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  The working hours may be changed from time to time to suit
                  specific site conditions. Furthermore, the second party is
                  expected to work the hours necessary to fulfil his duties and
                  remuneration for additional hours will be paid as per the KSA
                  Labour law
                </td>
                <td colspan="2">
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱) على أن يلتزم الطرف
                </td>
                <td>4</td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  The contract will automatically renew for other periods as
                  stated in item (1.2) of this contract- with the same terms and
                  privileges -unless one of the two parties informed the other, he
                  do not like to renew the contract prior 2 months of the
                  expiration of the current contract, with consideration to the
                  items Nos (37&55) of Saudi labor law.
                </td>
                <td colspan="2">
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱) على أن يلتزم ا
                </td>
                <td>5</td>
              </tr>
              <tr>
                <td>6</td>
                <td>
                  Your Leave entitlement is as follows 21 calendar days per annum.
                  The rotation cycle thereof will be issued on 24 months on and 42
                  calendar days off. To this, an economy class return air ticket
                  to home country will be issued to yourself every two years.
                </td>
                <td colspan="2">
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱) على أن يلتزم
                </td>
                <td>6</td>
              </tr>
            </tbody>
          </table>
          <div class="fLines lines"></div>
          <div class="lines"></div>
          <div class="footer">
            <p>
              لمملكة العربية السعودية - الرياض - الدائري الشرقي - مخرج 13 <br />
              Kingdom of Saudi Arabia - Riyadh - Eastern Ring - Outlet 13
            </p>
          </div>
        </div>
        <div class="page-2" style="margin-top:80px">
          <center><img src="asset/Mosaed_logo.JPG" /></center>
          <table class="header">
            <tr>
              <td>
                <b
                  >Mosaed Business Contracting Co.<br />
                  C.R. 1010777155
                </b>
              </td>
              <td class="last-child">
                <b>شركة مساعد الأعمال للمقاولات س :ت <br />1010777155</b>
              </td>
            </tr>
          </table>
          <div class="lines"></div>
          <div class="lines"></div>
  
          <table class="table-4">
            <tbody>
              <tr>
                <th></th>
                <th>Salary & allowances</th>
                <th>شركة مساعد الأعمال للمقاولات س :ت</th>
                <th></th>
              </tr>
              <tr>
                <td>7.1</td>
                <td>Job Title: HEAVY DRIVER CUM LOADING UNLOADING</td>
                <td>HEAVY DRIVER CUM LOADING UNLOADING</td>
                <td>7.1</td>
              </tr>
              <tr>
                <td>7.2</td>
                <td>Duration: 2 years (Two years)</td>
                <td></td>
                <td>1.2</td>
              </tr>
              <tr>
                <td>7.3</td>
                <td>Contract starting Date: 1/5/2023</td>
                <td>1/5/2023</td>
                <td>1.3</td>
              </tr>
              <tr>
                <td>1.4</td>
                <td>Probation Period: 3 months (Three months)</td>
                <td>التجربة يعمل الطرف الثاني</td>
                <td>1.4</td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  The second party will work for the first party in his main
                  office or one of its branches or any place belonging to the
                  first party inside K.S.A as per the contract terms in position
                  of (1.1), the second party will oblige to do his duties and
                  responsibilities as required by the first party.
                </td>
                <td>
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱) على أن يلتزم الطرف الثاني بأداء واجباته
                  ومسئولياته وكل ما يتعلق بوظيفته مما
                </td>
                <td>2</td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  Working hours will be 9hrs including prayer break hours per day
                  (6 days per week). Friday will be the official weekly rest day.
                  Excluded from this clause, will be some departments that are
                  required to work on Fridays in which case another day of the
                  week will be a rest day.
                </td>
                <td>
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱)
                </td>
                <td>3</td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  The working hours may be changed from time to time to suit
                  specific site conditions. Furthermore, the second party is
                  expected to work the hours necessary to fulfil his duties and
                  remuneration for additional hours will be paid as per the KSA
                  Labour law
                </td>
                <td>
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱) على أن يلتزم الطرف
                </td>
                <td>4</td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  The contract will automatically renew for other periods as
                  stated in item (1.2) of this contract- with the same terms and
                  privileges -unless one of the two parties informed the other, he
                  do not like to renew the contract prior 2 months of the
                  expiration of the current contract, with consideration to the
                  items Nos (37&55) of Saudi labor law.
                </td>
                <td>
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱) على أن يلتزم ا
                </td>
                <td>5</td>
              </tr>
              <tr>
                <td>6</td>
                <td>
                  Your Leave entitlement is as follows 21 calendar days per annum.
                  The rotation cycle thereof will be issued on 24 months on and 42
                  calendar days off. To this, an economy class return air ticket
                  to home country will be issued to yourself every two years.
                </td>
                <td>
                  فتترة التجربة : 3 اشهر تحت التجربة يعمل الطرف الثاني لدى الطرف
                  الأول في المركز الرئيسي أو أحد الفروع أو أي مكان تابع للطرف
                  الأول من الأماكن المنتشرة بالمملكة العربية السعودية وذلك وفق
                  بنود العقد بوظيفة (۱۱) على أن يلتزم
                </td>
                <td>6</td>
              </tr>
            </tbody>
          </table>
          <div class="since">Yours Sincerely,</div>
          <div class="sign">
            <table class="sign-table">
              <tr>
                <td>
                  <b>OKAP MUFADI G. ALENIZY <br />Managing Director</b
                  ><br />Mosaed Business Contracting Co
                </td>
                <td>
                  (Signature/التوقيع ) <br />
                  <b>Name: PRAVEEN KUMAR</b>
                  <br />Passport Number:S7506493 <br />
                  <u>Thumb Impression/البصمة</u>
                </td>
              </tr>
            </table>
          </div>
          <div class="fLines lines"></div>
          <div class="lines"></div>
          <div class="footer">
            <p>
              لمملكة العربية السعودية - الرياض - الدائري الشرقي - مخرج 13 <br />
              Kingdom of Saudi Arabia - Riyadh - Eastern Ring - Outlet 13
            </p>
          </div>
        </div>
        <div class="page-3" style="margin-top:220px">
          <center><img src="asset/Mosaed_logo.JPG" /></center>
          <table class="header">
            <tr>
              <td>
                <b
                  >Mosaed Business Contracting Co.<br />
                  C.R. 1010777155
                </b>
              </td>
              <td class="last-child">
                <b>شركة مساعد الأعمال للمقاولات س :ت <br />1010777155</b>
              </td>
            </tr>
          </table>
          <div class="lines"></div>
          <div class="lines"></div>
          <div class="undertaking">
            <div>
              <u><b>TO WHOMSOEVER IT MAY CONCERN </b></u>
            </div>
            <div class="undertaking-a">اللى من يهمة الأمر</div>
            <div class="undertaking-d"><b>UNDERTAKING DECLARATION</b></div>
            <div class="undertaking-d-a">التعهد إعلان</div>
          </div>
          <div class="date-u">Date: 1/5/2023</div>
          <table class="u-table-header">
            <tr>
              <td>
                1, PRAVEEN KUMAR bearing INDIAN Passport Number S7506493 hereby
                confirm my employment as HEAVY DRIVER CUM LOADING UNLOADING from
                with Mosaed Business Contracting Co., for 2 years on the below
                Terms & Conditions:
              </td>
              <td>
                ا PRAVEEN KUMAR, الجنسية INDIAN رقم جواز السفر 57506493 أقر بهذا
                التعهد بصفتي HEAVY DRIVER CUM LOADING UNLOADING من مع شركة مساعد
                الأعمال المحدودة ، الالتزام بجميع الشروط والأحكام بداية العقد
              </td>
            </tr>
          </table>
          <table class="u-table">
            <tbody>
              <tr>
                <td>1</td>
                <td>Contract Starting from</td>
                <td>1/5/2023</td>
                <td>الراتب</td>
                <td>1</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Contract for (period)</td>
                <td>2 years(Gregorian)/td></td>
                <td>الراتب</td>
                <td>2</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Work Location</td>
                <td>Anywhere in KSA</td>
                <td>الراتب</td>
                <td>3</td>
              </tr>
              <tr class="salary-row">
                <td rowspan="6">4</td>
                <td rowspan="6" class="salary-E">
                  Salary details<br />
                  <div class="table-intend">
                    a) Basic Salary<br />
                    b) Food Allowance <br />c) Accommodation <br />d)
                    Transportation<br />
                    e) Incentive
                  </div>
                </td>
                <td></td>
                <td rowspan="6" class="salary-A">
                  a )الراتب الاساسي <br />b) بدل الطعام بدل السكن <br />d) بدل
                  النقل e حافز أ<br />e) اجمالي الراتب
                </td>
                <td rowspan="6">4</td>
              </tr>
              <tr>
                <td>SAR 1600 per month</td>
              </tr>
              <tr>
                <td>SAR 200 per month</td>
              </tr>
              <tr>
                <td>Provided by Company</td>
              </tr>
              <tr>
                <td>Provided by Company</td>
              </tr>
              <tr>
                <td>SAR 400 per Month</td>
              </tr>
              <tr>
                <td></td>
                <td>f) Total Salary (SAR)</td>
                <td>SAR 2200 per month</td>
                <td>حافز</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <table class="Due-table">
            <tr>
              <td>
                Due to any circumstances (excluding serious health issues), if the
                contract is broken by Employee prior to 2 years' period, SAR
                8,000/- will be the amount for Repatriation (Exit) & SAR 15,000/-
                will be the amount for Transfer (to other company) to be paid by
                the Employee.
              </td>
              <td>
                بسبب أي ظرف من الظروف بإستثناء القضايا الصحية وفي حال عدم المدة
                المتفق عليها يتعهد الموظف بسداد (8000) ثمانية حسب اكمال العقد الاف
                وفي حال نقل الكفالة يدفع الموظف (15000) خمسة عشر الف ريال
              </td>
            </tr>
            <tr>
              <td>
                I hereby agree that I reviewed and understood all the contract
                items and contents and I have nothing to criticize the contract
                contents or anything else, also I am well known of all its
                conditions and items and contents.
              </td>
              <td>
                لقد راجعت وفهمت كل بنود العقد ومضمونه وليس لدي أي شيء لانتقاد
                محتويات العقد أو أي شيء آخر، كما أنني فهمت جميع احكامه وبنوده
                ومواده
              </td>
            </tr>
          </table>
          <div class="sign">
            (<b>PRAVEEN KUMAR </b> Signature / التوقي) <br />Passport
            Number:S7506493 <br />
            <u>Thumb Impression/البصمة</u>
          </div>
          <div class="fLines lines"></div>
          <div class="lines"></div>
          <div class="footer" style="padding-bottom:50px">
            <p>
              لمملكة العربية السعودية - الرياض - الدائري الشرقي - مخرج 13 <br />
              Kingdom of Saudi Arabia - Riyadh - Eastern Ring - Outlet 13
            </p>
          </div>
        </div>
      </div>
    </body>
  </html>
  
  `;

  return content;
}
